// src/pages/SalarySlipStatusPage.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Salarystatus.css";
import apiClient from "../utils/apiClient"; // ✅ global API client
import SessionHandler from "../components/SessionHandler"; // ✅ global session expiry modal

const SalarySlipStatusPage = () => {
  const navigate = useNavigate();

  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await apiClient(
          "/salary-slip/salary-slip-status/"
        );

        if (!data) return;

        if (Array.isArray(data)) {
          setRequests(data);
        } else if (Array.isArray(data.results)) {
          setRequests(data.results);
        } else if (Array.isArray(data.data)) {
          setRequests(data.data);
        } else {
          setRequests([]);
        }
      } catch (error) {
        console.error("Error fetching salary slip status:", error);
        setRequests([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="salary-slip-status-container">
      {/* 🔙 Back Button */}
      <button
        onClick={() => navigate(-1)}
        style={{
          marginBottom: "15px",
          background: "#555",
          padding: "8px 14px",
          borderRadius: "5px",
        }}
      >
        ←
      </button>

      <h2 className="salary-slip-status-title">Salary Slip Status</h2>

      {loading ? (
        <p className="loading-text">Loading...</p>
      ) : requests.length === 0 ? (
        <p className="no-data-text">No salary slip requests found.</p>
      ) : (
        <table className="salary-slip-status-table">
          <thead>
            <tr>
              <th>From Month</th>
              <th>To Month</th>
              <th>Status</th>
              <th>Requested Date</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((req, index) => (
              <tr key={index}>
                <td>{req.from_month}</td>
                <td>{req.to_month}</td>
                <td className={`status ${req.status?.toLowerCase()}`}>
                  {req.status}
                </td>
                <td>
                  {req.requested_at
                    ? new Date(req.requested_at).toLocaleDateString()
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* ✅ Global session expiry modal */}
      <SessionHandler />
    </div>
  );
};

export default SalarySlipStatusPage;
